import { hotjar } from 'react-hotjar';
import { cdnUrl } from '../constants/generic';
import { InitSiteData } from '../ts/interfaces/Generic';
import * as idb from 'utils/shared/idbUrl';

export const initLoader = () => {
  const loader = {
    loadingPage: {
      systemProducts: 'Hotels',
      systemProductsDetails: 'Loading',
      listOfGalleryId: [
        {
          code: '/s3/prod.beprotravel/135/BeTop/CMSGALLERY/loading/loader_c3a410fd.gif',
          alt: '',
        },
      ],
    },
  };
  localStorage.setItem('allLoadings', JSON.stringify({ loadings: [loader] }));
};

export const initCSSVars = (siteData: InitSiteData) => {
  if (siteData.companyId === 135) {
    document.body.classList.add('enigma');
  }
  if (siteData.companyId === 109) {
    document.body.classList.add('safaraura');
  }
};
export const changeFavicon = (url: string): void => {
  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.href = url;
};

const getBuildVersion = async (fallbackVersion: string) => {
  try {
    const response = await fetch('/version.txt', { cache: 'no-store' });
    if (!response.ok) {
      return fallbackVersion;
    }

    const version = (await response.text()).trim();
    return version || fallbackVersion;
  } catch {
    return fallbackVersion;
  }
};

export const configureStorage = async () => {
  localStorage.setItem('devUrl', cdnUrl);
  sessionStorage.setItem('currencySymbolBefore', 'true');
  const localGlobalsVersion = localStorage.getItem('globalsVersion');
  const globalsVersion = 'v1';
  localStorage.setItem('globalsVersion', globalsVersion);
  const stor = localStorage.getItem('storageVersion');
  const cookie = localStorage.getItem('cookie-policy-result');
  const globals = localStorage.getItem('globals');
  const storedState = sessionStorage.getItem(`userPkce_state`);
  const verifier = sessionStorage.getItem(`userPkce_verifier`);
  const version = await getBuildVersion(stor || 'dev');
  if (stor !== version) {
    localStorage.clear();
    sessionStorage.clear();

    if (cookie) {
      localStorage.setItem('cookie-policy-result', cookie);
    }

    if (globals && localGlobalsVersion === globalsVersion) {
      localStorage.setItem('globals', globals);
    }

    if (storedState) {
      sessionStorage.setItem(`userPkce_state`, storedState);
    }

    if (verifier) {
      sessionStorage.setItem(`userPkce_verifier`, verifier);
    }
  }
  localStorage.setItem('storageVersion', version);

  // const lang = localStorage.getItem('language');
  // if (!lang) {
  //   localStorage.setItem('language', 'en');
  // }
};
export const initHotjar = () => {
  const initDataStr = localStorage.getItem('initSiteData');
  if (!initDataStr) return;

  const initData = JSON.parse(initDataStr);

  if (process.env.REACT_APP_DEBUG) return;

  if (initData.other.hotjarId && initData.other.hotjarVersion) {
    hotjar.initialize({ id: +initData.other.hotjarId, sv: +initData.other.hotjarVersion });
    console.log('hotjar initialized', hotjar.initialized());
  }
};

export const clearIdb = () => {
  idb.deleteProposal('proposal');
  idb.deletePageStateByPartialKey('hotels');
  idb.deletePageStateByPartialKey('flights');
  idb.deletePageStateByPartialKey('dynamic');
  idb.deletePageStateByPartialKey('transfers');
  idb.deletePageStateByPartialKey('ilpackages');
  idb.deletePageStateByPartialKey('proposal');
};
